export default __webpack_public_path__ + "static/media/Autokritigallery_28.1dba7a59.JPG";